<template>
  <div class="input-password" :class="classes">
    <input
      :type="type"
      :value="value"
      :name="name"
      :id="id"
      v-bind="$props"
      v-on:input="updateValue($event.target.value)"
    />
    <img v-bind:src="'/images/icon-eye.svg'" alt class="icon-eye" @click="showPassword" />
  </div>
</template>

<script>
export default {
  name: "InputPassword",
  props: {
    classes: {
      type: String
    },
    value: {
      type: String
    },
    name: {
      type: String
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      type: "password",
      content: this.value
    };
  },
  methods: {
    showPassword() {
      if (this.type === "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    updateValue: function(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss">
.input-password {
  box-sizing: border-box;
  clear: both;
  position: relative;
  text-align: left;
  padding: 0.375rem 0.75rem;
  border-radius: 3px;

  input {
    border: 0;
    width: 100%;
    padding-right: 2.25em;

    &:focus {
      outline: none;
    }
  }

  .icon-eye {
    cursor: pointer;
    height: 2.25em;
    position: absolute;
    top: 0;
    width: 2.25em;
    z-index: 4;
    right: 0;
  }
}
</style>
